import SoultanF1 from '../../../src/media/Fasilitas/Fasilitas Chelia (1).webp'
import SoultanF2 from '../../../src/media/Fasilitas/Fasilitas Chelia (2).webp'
import SoultanF3 from '../../../src/media/Fasilitas/Fasilitas Chelia (3).webp'



const SoultanFimages =[
SoultanF1,SoultanF2,SoultanF3]

export default SoultanFimages;